module.exports = __webpack_public_path__ + "media/images/products/h4-42a1850c4447a848f635512725380f59.jpg";